function Logo() {
  return (
    <div className="logo">
      <p className="logo__text">
        Movie
        <br />
        Searcher
      </p>
    </div>
  );
}

export default Logo;
